type TitleType = {
  children: any
  size?: 'text-4xl' | 'text-3xl' | 'text-2xl' | 'text-xl'
}

export const Title = ({ children, size = 'text-4xl' }: TitleType) => {
  return <h2 className={`text-primary-dark font-poppins font-bold ${size}`}>{children}</h2>
}